export function VideoPlayer() {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <video
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
        autoPlay
        controls
      >
        <source src="/rannis-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
